<auth-layout
  *ngIf="useAuthShell; else classicLayout"
  [showLoginAction]="showLoginAction"
  [showCalculatorAction]="showCalculatorAction"
>
  <router-outlet></router-outlet>
</auth-layout>

<ng-template #classicLayout>
  <ui-app-layout>
    <ui-side-menu>
      <section class="ui-menu-header">
        <div class="header-row">
          <ui-jct-logo *ngIf="!appLayout.isMobile" [solid]="true" [includePadding]="false" [width]="62"> </ui-jct-logo>

          <span class="ui-menu-brand">
            <span class="ui-menu-brand__title" i18n>המרכז האקדמי לב</span>
            <span class="ui-menu-brand__subtitle" i18n>מערכת הרישום</span>
          </span>
        </div>
      </section>

      <ui-menu-item route="/start">
        <ui-menu-content icon="edit" i18n> התחל בתהליך הרישום </ui-menu-content>
      </ui-menu-item>

      <ui-menu-item route="/reset-process">
        <ui-menu-content icon="lock_open" i18n> איפוס סיסמה שנשכחה </ui-menu-content>
      </ui-menu-item>

      <ui-menu-item route="/sent-new-password">
        <ui-menu-content icon="lock_open" i18n> סיסמה חדשה למייל </ui-menu-content>
      </ui-menu-item>

      <ui-menu-item *ngIf="!userProfile.isAmerican" route="/calculator">
        <ui-menu-content icon="computer" i18n> מחשבון ציון התאמה </ui-menu-content>
      </ui-menu-item>

      <ui-menu-item route="/contact">
        <ui-menu-content icon="phone" i18n> יצירת קשר </ui-menu-content>
      </ui-menu-item>

      <mat-divider *ngIf="appLayout.isXSmall && l10n.enabled"></mat-divider>

      <ui-menu-item *ngIf="appLayout.isXSmall && l10n.enabled" (action)="l10n.openLanguageSelector()">
        <ui-menu-content icon="language" i18n> שנוי שפת תצוגה </ui-menu-content>
      </ui-menu-item>
    </ui-side-menu>

    <section ui-toolbar-header class="ui-toolbar-header">
      <span class="ui-toolbar-brand" *ngIf="appLayout.isMobile">
        <ui-jct-logo [solid]="true" [includePadding]="false" [width]="40"></ui-jct-logo>
        <span class="ui-toolbar-brand__text">
          <span class="ui-toolbar-brand__title" i18n>המרכז האקדמי לב</span>
          <span class="ui-toolbar-brand__subtitle" i18n>מערכת הרישום</span>
        </span>
      </span>

      <span *ngIf="!appLayout.isMobile">
        {{ pageTitle?.current }}
      </span>
    </section>

    <section ui-toolbar-actions class="ui-toolbar-actions">
      <language-menu *ngIf="!appLayout.isMobile"></language-menu>
    </section>
  </ui-app-layout>
</ng-template>
